import { Grid } from "@mui/material";
import { FunctionField, Labeled, ReferenceField, TextField, useRecordContext } from "react-admin";
import { administrationRequests } from "api/administrationApi";
import DoctoralDateField from "../../Partials/DoctoralDateField";

const PreviousEducations = () => {
  const record = useRecordContext();
  const education = record?.previousEducation;
  if (!education) return <em>Няма данни</em>;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <Labeled label="Специалност">
          <TextField source="previousEducation.speciality" emptyText="—" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Образователно-квалификационна степен">
          {education.degreeId ? (
            <ReferenceField
              source="previousEducation.degreeId"
              reference={administrationRequests.getDegreesSelect()}
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          ) : (
            <FunctionField render={() => "—"} />
          )}
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Квалификация">
          <TextField source="previousEducation.qualification" emptyText="—" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Висше училище">
          <TextField source="previousEducation.diplomaUniversity" emptyText="—" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Серия на диплома">
          <TextField source="previousEducation.diplomaSeries" emptyText="—" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Номер на диплома">
          <TextField source="previousEducation.diplomaNumber" emptyText="—" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Регистрационен номер">
          <TextField source="previousEducation.diplomaRegistrationNumber" emptyText="—" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Дата на диплома">
          <DoctoralDateField source="previousEducation.diplomaDate" emptyText="—" />
        </Labeled>
      </Grid>
    </Grid>
  );
};

export default PreviousEducations;
